import { DisclosureHost } from "../hooks/use-disclosure";
import SideSheetDrawer from "./SidesheetDrawer";

interface PdfViewDrawerProps {
  file?: string;
  disclosureHost: DisclosureHost;
  onClose?: () => void;
  title?: string;
  w?: string;
}

/**
 * @description- To View,print & save PDF format files
 *
 * @param DisclosureHost {DisclosureHost}
 *
 * @author Rajkumar Rathod
 */
const PdfViewDrawer: React.FC<PdfViewDrawerProps> = ({
  file,
  onClose,
  disclosureHost: disClosureHost,
  title,
  w = "100vw",
}) => {
  return (
    <SideSheetDrawer
      w={w}
      open={disClosureHost.opened}
      title={title ?? "Print"}
      onClose={onClose || disClosureHost.close}
    >
      <iframe
        src={file}
        style={{ height: "calc(100svh - 120px)", width: "100%" }}
      />
    </SideSheetDrawer>
  );
};

export default PdfViewDrawer;
